import { createFileRoute, Outlet } from "@tanstack/react-router";
import { StepFlowLayout } from "~/components/layouts/StepFlowLayout";
import { useFlowStart } from "~/hooks/use-flow-start";

export const Route = createFileRoute("/(authenticated)/energiefactuur-uploaden")({
  component: EnergyfactuurUploadenLayout,
});

function EnergyfactuurUploadenLayout() {
  useFlowStart("energiefactuur_upload");

  return (
    <StepFlowLayout currentStep={1} totalSteps={1}>
      <Outlet />
    </StepFlowLayout>
  );
}
